module.exports = __webpack_public_path__ + "static/media/YM36_2.8693666c.jpg";